<template>
  <div class="habilitation">
    <div class="habilitation__main">
      <div class="d-flex align-items-baseline">
        <div class="habilitation__gategory mr-4">
          <h2>{{ habilitation.code }}</h2>
        </div>
        <div class="habilitation__segment mr-4">
          <select
            class="form-control p-0 pl-2"
            id="category"
            :placeholder="$t('category')"
            v-model="segment"
            @change="getSegmentInfo"
          >
            <option
              v-for="(item, segmentIndex) in habilitation.segments"
              :value="item"
              :key="segmentIndex"
            >
              {{ item.code }}
            </option>
          </select>
        </div>
        <span class="habilitation-segment-title">{{ title }}</span>
      </div>
      <div>
        <a
          :href="habilitationStatistics"
          class="btn btn-primary btn-icon"
        >
          {{ $t('statistics') }} <span class="icon icon-file_white"></span>
        </a>
      </div>
      <div class="habilitation__actions">
        <div class="w-100">
          <a
            class="btn btn-icon-right link-show collapsed w-100 ml-2"
            type="button"
            data-toggle="collapse"
            :data-target="'#habilitation-' + index"
            aria-expanded="false"
            :aria-controls="'habilitation-' + index"
            @click="toggleCollapse"
          >
            <span class="link-show__on" />
            <span class="link-show__off" />
            <span class="icon" />
          </a>
        </div>
      </div>
    </div>

    <div class="row d-flex align-items-center">
      <div class="col-md-9 d-lg-flex">
        <statistic-box
          :title="$t('statisticBoxTotal')"
          :number="totalTrainees"
        />
        <statistic-box
          :title="$t('form.mandatory')"
          :label-color="'text-primary'"
          :number="totalMandatoryTrainees"
        />
        <statistic-box
          :title="$t('trained')"
          :label-color="'text-primary'"
          :number="totalTrainedTrainees"
        />
        <statistic-box
          :title="$t('notTrained')"
          :label-color="'text-primary'"
          :number="totalNotTrainedTrainees"
        />
        <statistic-box
          :title="$t('toDoRefresher')"
          :label-color="'text-danger'"
          :number="totalToBeRecycleTrainedTrainees"
        />
        <statistic-box
          :title="$t('ToDoInitial')"
          :label-color="'text-danger'"
          :number="totalToBeInitialTrainedTrainees"
        />
        <statistic-box
          :title="$t('scheduled')"
          :label-color="'text-danger'"
          :number="totalScheduledTrainees"
        />
      </div>
      <div class="col-md-3">
        <trained-peaple-chart :percentage="percentage"></trained-peaple-chart>
      </div>
    </div>
    <div class="habilitation__desc-category mb-0 text-primary">
      {{ $t("statisticBoxHabilitationStatus") }}
    </div>
    <div class="habilitation__desc-category mb-0 text-danger">
      {{ $t("statisticBoxRegistrationStatus") }}
    </div>
    <div class="row d-flex align-items-center">
      <div
        class="col-12 habilitation__dates collapse"
        :id="'habilitation-' + index"
      >
        <div
          class=""
          v-if="isLoaded"
        >
          <traineedEmployees
            :trainees="filteredTrainedTrainees"
            :habilitationCode="habilitation.code"
            :segment="segment"
            :index="index"
            :isUpdating="istrainedTraineesUpdating"
          />

          <employees-to-be-recycled
            :trainees="filteredToBeRecycledTrainees"
            :habilitationCode="habilitation.code"
            :segment="segment"
            :index="index"
            :isUpdating="isToBeRecycledUpdating"
          />
          <employees-to-be-initialy-trained
            :trainees="filteredToBeinitialeddTrainees"
            :habilitationCode="habilitation.code"
            :segment="segment"
            :index="index"
            :isUpdating="isToBeInitaledUpdating"
          />
          <employees-to-be-scheduled
            :trainees="filteredToBeScheduledTrainees"
            :habilitationCode="habilitation.code"
            :segment="segment"
            :index="index"
            :isUpdating="isToBeScheduledUpdating"
          />
          <employees-mandatory
            :trainees="filteredNotHabilitatedTrainees"
            :habilitationCode="habilitation.code"
            :segment="segment"
            :index="index"
            :isUpdating="isMandatoryUpdating"
          />
        </div>

        <div
          class=""
          v-else
        >
          <div
            class="d-flex justify-content-center align-items-center"
            style="min-height: 200px"
          >
            <div class="d-flex justify-content-center align-items-center">
              <div
                class="spinner-border"
                role="status"
              >
                <span class="sr-only"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'HabilitationBox',
  props: ['habilitation', 'index', 'service', 'services'],
  components: {
    TrainedPeapleChart: () => import('./TrainedPeapleChart.vue'),
    StatisticBox: () => import('./StatisticBox.vue'),
    TraineedEmployees: () => import('./traineedEmployees/index.vue'),
    EmployeesToBeRecycled: () => import('./employeesToBeRecycled/index.vue'),
    EmployeesToBeScheduled: () => import('./employeesToBeScheduled/index.vue'),
    EmployeesToBeInitialyTrained: () =>
      import('./employeesToBeInitialyTrained/index.vue'),
    EmployeesMandatory: () => import('./employeesMandatory/index.vue')
  },
  data() {
    return {
      segment: {},
      segmentObj: {},
      title: '',
      percentage: 0,
      totalTrainees: 0,
      totalMandatoryTrainees: 0,
      totalTrainedTrainees: 0,
      totalNotTrainedTrainees: 0,
      totalToBeRecycleTrainedTrainees: 0,
      totalToBeInitialTrainedTrainees: 0,
      totalNeededTrainees: 0,
      totalScheduledTrainees: 0,
      habilitatedTrainees: {},
      notHabilitatedTrainees: [],
      isLoaded: false,
      collapsed: false,
      isMandatoryUpdating: false,
      isToBeInitaledUpdating: false,
      isToBeScheduledUpdating: false,
      isToBeRecycledUpdating: false,
      istrainedTraineesUpdating: false
    };
  },
  computed: {
    ...mapFields(['user', 'company', 'establishment']),
    ...mapFields([
      'monitoring.habilitations',
      'monitoring.selectedTraineedEmployees',
      'monitoring.selectedEmployeesToRecycled',
      'monitoring.selectedEmployeesToBeInitialyTrained',
      'monitoring.selectedEmployeesToBeScheduleTrained',
      'monitoring.selectedEmployeesToMandatory'
    ]),
    habilitationStatistics() {
      let url = this.$lodash.get(this.habilitation, 'statistics', '');
      if (this.service) url += '&service=' + this.service;
      return url;
    },
    filteredTrainedTrainees() {
      return this.filter(this.habilitatedTrainees.trainedTrainees);
    },
    filteredToBeRecycledTrainees() {
      return this.filter(this.habilitatedTrainees.toBeRecycledTrainees);
    },
    filteredToBeinitialeddTrainees() {
      return this.filter(this.habilitatedTrainees.toBeinitialeddTrainees);
    },
    filteredToBeScheduledTrainees() {
      return this.filter(this.habilitatedTrainees.toBeScheduledTrainees);
    },
    filteredToBeMandatoryTrainees() {
      return this.filter(this.habilitatedTrainees.toBeMandatoryTrainees);
    },
    filteredNotHabilitatedTrainees() {
      return this.filter(this.notHabilitatedTrainees);
    },
    serviceValue() {
      const s = this.services.find(item => item.id === this.service);
      return s ? s.label : null;
    }
  },
  mounted() {
    this.segment = this.habilitation.segments[0];
    let selectedTraineedEmployees = {
      [this.habilitation.code]: []
    };
    this.selectedTraineedEmployees = {
      ...this.selectedTraineedEmployees,
      ...selectedTraineedEmployees
    };
    let selectedEmployeesToMandatory = {
      [this.habilitation.code]: []
    };
    this.selectedEmployeesToMandatory = {
      ...this.selectedEmployeesToMandatory,
      ...selectedEmployeesToMandatory
    };
    let selectedEmployeesToRecycled = {
      [this.habilitation.code]: []
    };
    this.selectedEmployeesToRecycled = {
      ...this.selectedEmployeesToRecycled,
      ...selectedEmployeesToRecycled
    };
    let selectedEmployeesToBeInitialyTrained = {
      [this.habilitation.code]: []
    };
    this.selectedEmployeesToBeInitialyTrained = {
      ...this.selectedEmployeesToBeInitialyTrained,
      ...selectedEmployeesToBeInitialyTrained
    };
    let selectedEmployeesToBeScheduleTrained = {
      [this.habilitation.code]: []
    };
    this.selectedEmployeesToBeScheduleTrained = {
      ...this.selectedEmployeesToBeScheduleTrained,
      ...selectedEmployeesToBeScheduleTrained
    };
    this.percentage = this.segment.percentage;
    this.totalTrainees = this.segment.totalTrainees;
    this.title = this.segment.title;
    this.totalMandatoryTrainees = this.segment.totalMandatoryTrainees;
    this.totalTrainedTrainees = this.segment.totalTrainedTrainees;
    this.totalNotTrainedTrainees = this.segment.totalNotTrainedTrainees;
    this.totalToBeRecycleTrainedTrainees =
      this.segment.totalToBeRecycleTrainedTrainees;
    this.totalToBeInitialTrainedTrainees =
      this.segment.totalToBeInitialTrainedTrainees;
    this.totalNeededTrainees = this.segment.totalNeededTrainees;
    this.totalScheduledTrainees = this.segment.totalScheduledTrainees;
    this.$bus.$on('update-monitoring-trainees', (index) => {
      if (this.index == index) {
        this.getSegmentInfo().then(() => {
          this.isUpdating = false;
          Swal.fire({
            type: 'success',
            text: this.$t('removeMandatorySuccess')
          });
        });
      }
    });
    this.$bus.$on('is-mandatory-updating', (data) => {
      if (this.index == data.index) {
        this.isMandatoryUpdating = data.status;
      }
    }),
      this.$bus.$on('is-to-be-recycled-updating', (data) => {
        if (this.index == data.index) {
          this.isToBeRecycledUpdating = data.status;
        }
      }),
      this.$bus.$on('is-to-be-initialed-updating', (data) => {
        if (this.index == data.index) {
          this.isToBeInitaledUpdating = data.status;
        }
      }),
      this.$bus.$on('is-to-be-scheduled-updating', (data) => {
        if (this.index == data.index) {
          this.isToBeScheduledUpdating = data.status;
        }
      }),
      this.$bus.$on('delete-mandatory-trainees', (index) => {
        if (this.index == index) {
          this.getSegmentInfo().then(() => {
            this.isMandatoryUpdating = false;
            Swal.fire({
              type: 'success',
              text: this.$t('deleteInscriptionSuccess')
            });
          });
        }
      })
    this.$bus.$on('update-mandatory-trainees', (index) => {
      if (this.index == index) {
        this.getSegmentInfo().then(() => {
          this.isMandatoryUpdating = false;
          this.selectedEmployeesToMandatory[this.habilitation.code] = [];
          Swal.fire({
            type: 'success',
            text: this.$t('addMandatorySuccess')
          });
        });
      }
    });
    this.$bus.$on('update-to-be-recycled-trainees', (index) => {
      if (this.index == index) {
        this.getSegmentInfo().then(() => {
          this.isToBeRecycledUpdating = false;
          this.selectedEmployeesToRecycled[this.habilitation.code] = [];
          Swal.fire({
            type: 'success',
            text: this.$t('removeMandatorySuccess')
          });
        });
      }
    });
    this.$bus.$on('update-to-be-initaled-trainees', (index) => {
      if (this.index == index) {
        this.getSegmentInfo().then(() => {
          this.isToBeInitaledUpdating = false;
          this.selectedEmployeesToBeInitialyTrained[this.habilitation.code] =
            [];
          Swal.fire({
            type: 'success',
            text: this.$t('removeMandatorySuccess')
          });
        });
      }
    });
    this.$bus.$on('update-to-be-scheduled-trainees', (index) => {
      if (this.index == index) {
        this.getSegmentInfo().then(() => {
          this.isToBeScheduledUpdating = false;
          //this.selectedEmployeesToBeInitialyTrained[ this.habilitation.code ] =
          [];
          Swal.fire({
            type: 'success',
            text: this.$t('removeMandatorySuccess')
          });
        });
      }
    });
  },
  beforeDestroy() {
    //do something before destroying vue instance
    this.$bus.$off('update-to-be-recycled-trainees');
    this.$bus.$off('update-to-be-initaled-trainees');
    this.$bus.$off('update-mandatory-trainees');
    this.$bus.$off('is-to-be-initialed-updating');
    this.$bus.$off('is-mandatory-updating');
    this.$bus.$off('is-to-be-recycled-updating');
  },
  methods: {
    filter(data) {
      return data
        ? data.filter(item => this.serviceValue ? item.service === this.serviceValue : true)
        : [];
    },
    downloadHabilitationStatistics() {
      let data = {
        clientId: this.user.id,
        companyId: this.company.id,
        establishmentId: this.establishment.id,
        category: this.habilitation.code
      };
      this.$store
        .dispatch('monitoring/downloadHabilitationStatistics', data)
        .then((resp) => {
        });
    },

    getSegmentInfo() {

      let data = {
        category: this.habilitation.code,
        segment: this.segment,
        companyId: this.$lodash.get(this.company, 'id', null),
        establishmentId: this.$lodash.get(this.establishment, 'id', null),
        service: this.service
      };
      return this.$store
        .dispatch('monitoring/getHabilitationBySegment', data)
        .then((resp) => {
          this.habilitatedTrainees = resp.habilitatedTrainees;
          this.notHabilitatedTrainees = resp.notHabilitatedTrainees;

          this.percentage = this.segment.percentage;
          this.totalTrainees = this.segment.totalTrainees;
          this.title = this.segment.title;
          this.totalMandatoryTrainees = this.segment.totalMandatoryTrainees;
          this.totalTrainedTrainees = this.segment.totalTrainedTrainees;
          this.totalNotTrainedTrainees = this.segment.totalNotTrainedTrainees;
          this.totalToBeRecycleTrainedTrainees =
            this.segment.totalToBeRecycleTrainedTrainees;
          this.totalToBeInitialTrainedTrainees =
            this.segment.totalToBeInitialTrainedTrainees;
          this.totalNeededTrainees = this.segment.totalNeededTrainees;
          this.totalScheduledTrainees = this.segment.totalScheduledTrainees;
          this.isLoaded = true;
        });
    },
    toggleCollapse() {
      this.collapsed = !this.collapsed;
      if (this.collapsed && this.$lodash.isEmpty(this.habilitatedTrainees)) {
        this.getSegmentInfo();
      } else this.isLoaded = true;
    }
  }
};
</script>

<style scoped lang="scss">
.habilitation-segment-title {
  font-size: "O.75rem";
  width: 180px;
}
</style>
